const ICONS = {
    plus: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>',
    pencil: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/></svg>',
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>',
};

function iconButton(href, title, icon) {
    const link = document.createElement('a');
    link.href = href;
    link.className = 'btn btn-ghost btn-xs btn-circle';
    link.title = title;
    link.innerHTML = ICONS[icon];
    return link;
}

function buildNode(cat, groupId, config) {
    const li = document.createElement('li');
    li.className = 'cat-node';

    const row = document.createElement('div');
    row.className = 'cat-node-row';

    const hasChildren = cat.children && cat.children.length > 0;

    // Collapse toggle
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'cat-toggle';
    toggle.textContent = hasChildren ? '▾' : '▸';
    if (!hasChildren) {
        toggle.style.visibility = 'hidden';
    } else {
        toggle.addEventListener('click', () => {
            const childrenUl = li.querySelector('.cat-children');
            const isOpen = childrenUl.style.display !== 'none';
            childrenUl.style.display = isOpen ? 'none' : '';
            toggle.textContent = isOpen ? '▸' : '▾';
        });
    }
    row.appendChild(toggle);

    // Label: code + title
    const label = document.createElement('span');
    label.className = 'cat-label';

    if (cat.code) {
        const code = document.createElement('span');
        code.className = 'cat-code';
        code.textContent = cat.code;
        label.appendChild(code);
        label.appendChild(document.createTextNode(' '));
    }

    const title = document.createElement('span');
    title.className = 'cat-title';
    title.textContent = cat.title;
    label.appendChild(title);

    row.appendChild(label);

    // Action buttons
    const actions = document.createElement('span');
    actions.className = 'cat-actions';

    if (config.canManage) {
        actions.appendChild(iconButton(
            `${config.addUrl}?GroupID=${groupId}&ParentID=${cat.id}&BackURL=${encodeURIComponent(config.backUrl)}`,
            'Unterkategorie hinzufügen',
            'plus'
        ));

        actions.appendChild(iconButton(
            `${config.editUrl}/${cat.id}?BackURL=${encodeURIComponent(config.backUrl)}`,
            'Bearbeiten',
            'pencil'
        ));

        const delLink = iconButton(
            `${config.deleteUrl}/${cat.id}?BackURL=${encodeURIComponent(config.backUrl)}`,
            'Löschen',
            'trash'
        );
        delLink.addEventListener('click', (e) => {
            if (!confirm('Kategorie wirklich löschen?')) {
                e.preventDefault();
            }
        });
        actions.appendChild(delLink);
    }

    row.appendChild(actions);
    li.appendChild(row);

    // Children list
    if (hasChildren) {
        const childrenUl = document.createElement('ul');
        childrenUl.className = 'cat-children';
        cat.children.forEach(child => {
            childrenUl.appendChild(buildNode(child, groupId, config));
        });
        li.appendChild(childrenUl);
    }

    return li;
}

export function initCategoryTree() {
    const root = document.getElementById('category-tree-root');
    if (!root) return;

    const treeUrl = root.dataset.treeUrl;
    const config = {
        addUrl: root.dataset.addUrl,
        editUrl: root.dataset.editUrl,
        deleteUrl: root.dataset.deleteUrl,
        backUrl: root.dataset.backUrl,
        canManage: root.dataset.canManage === '1',
    };

    fetch(treeUrl)
        .then(r => {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
        })
        .then(data => {
            root.innerHTML = '';

            if (config.canManage) {
                const addBtn = document.createElement('a');
                addBtn.href = `${config.addUrl}?GroupID=${data.id}&BackURL=${encodeURIComponent(config.backUrl)}`;
                addBtn.className = 'btn btn-primary btn-sm';
                addBtn.textContent = '+ Wurzelkategorie hinzufügen';
                root.appendChild(addBtn);
            }

            const ul = document.createElement('ul');
            ul.className = 'cat-tree mt-4';

            if (!data.categories || data.categories.length === 0) {
                const empty = document.createElement('li');
                empty.className = 'opacity-60';
                empty.textContent = 'Keine Kategorien vorhanden.';
                ul.appendChild(empty);
            } else {
                data.categories.forEach(cat => {
                    ul.appendChild(buildNode(cat, data.id, config));
                });
            }

            root.appendChild(ul);
        })
        .catch(err => {
            console.error('Category tree error:', err);
            root.innerHTML = '<div class="alert alert-error">Fehler beim Laden des Kategoriebaums.</div>';
        });
}
